<template>
  <v-container grid-list-xl>
    <v-layout
      wrap
      justify-space-between
      v-if="mode=='recover_phone'"
    >
      <v-flex
        xs12
        md12
      >
          <h1>비번찾기</h1>
          <h1>Forgot Password</h1>

          <v-alert
            :value="true"
            type="info"
          >
            {{ message }}
          </v-alert>
          <div>
              <v-btn :to="`/recover_phone`" ><v-icon>fas fa-phone</v-icon>&nbsp; Phone Recovery</v-btn >
          </div>
      </v-flex>
    </v-layout>

    <v-layout
      wrap
      justify-space-between
      v-if="mode=='finish'"
    >
      <v-flex
        xs12
        md12
      >
          <h1>비번찾기</h1>
          <h1>Forgot Password</h1>
      </v-flex>

      <v-alert
        :value="true"
        type="info"
      >
        {{ message }}
      </v-alert>
    </v-layout>

    <v-layout
      wrap
      justify-space-between
      v-if="mode=='start'"
    >
      <v-flex
        xs12
        md12
      >
          <h1>비번찾기</h1>
          <h1>Forgot Password</h1>
      </v-flex>
      
      <v-flex
        xs12
        md12
      >
        <v-form ref="form" @submit.prevent="confirm">
          <v-layout row wrap>
            <v-flex pa-0 xs12>
		<v-subheader class='formlabel' >휴대전화 Mobile Phone Number</v-subheader>
            </v-flex>
            <v-flex py-0 xs3 formlabeless>
	      <v-select
		:items="countries"
		label=""
		prefix=""
		v-model="cc"
		xs6
	      ></v-select>
            </v-flex>
            <v-flex py-0 xs9 formlabeless>
	      <v-text-field
		v-model="phone"
		:rules="[rules.phone]"
		:error-messages="phone_error_messages"
		:disabled="phone_validated"
		@input="phone_error_messages = []"
		label=""
		type="number"
                pattern="\d*"
                clearable
	      ></v-text-field>
            </v-flex>
          </v-layout>
          <v-btn type='submit'>Forgot Password</v-btn>
        </v-form>
      </v-flex>
      <br/>
      </v-flex>
    </v-layout>


  </v-container>
</template>

<script>
import {fetcher} from '@/fetcher.js';
import {phone_countries} from '@/settings';
export default {
  props: ['auth'],
  data: () => ({
    recover_phone: false,
    cc: '+82',
    phone: '10',
    mode: 'start',
    message: '',
    password: '',
    password_error_messages: [],
    phone_validated: false,
    phone_error_messages: [],
    valid: false,
    countries: phone_countries,
    rules: {
      phone: value => {
        const pattern = /^\d*$/;
        return pattern.test(value) || 'Invalid phone number';
      },
    },
  }),
  mounted() {
    let oldcc = localStorage.getItem('last_cc');
    let oldphone = localStorage.getItem('last_phone');

    if (oldcc) {
      this.cc = oldcc;
    }
    if (oldphone) {
      this.phone = oldphone;
    }
  },
  watch: {
    phone(to) {
      if (to?.startsWith('0')) {
        this.$data.phone = to.replace(/^0/, '');
      }
    },
    cc(to, from) {
      if (to != '+82' && this.$data.phone == '10') {
        this.$data.phone = '';
      }
      if (to == '+82' && !this.$data.phone) {
        this.$data.phone = '10';
      }
    },
  },
  methods: {
    confirm: async function({router}) {
      if (!this.$refs.form.validate()) {
        return false;
      }

      let nicephone = this.$data.cc + this.$data.phone;
      var res = await fetcher.post('/myprofile/forgot_password', {
        cc: this.$data.cc,
        phone: nicephone,
      });
      console.log('verify result', res);

      if (!res.data.success) {
        this.message = res.data.message;
        this.recover_phone = res.data.recover_phone;
        if (this.recover_phone) { this.mode = "recover_phone" }
      } else {
        this.mode = 'finish';
        this.message = res.data.message;
        let cancelHandle = this.$scrollTo('#appbody'); // scroll to top of page
        return;
      }
    },
  },
};
</script>
